import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";

import logoIcon from "../../assets/images/logo-icon.png";
import {
  SCREEN_PATH,
  EMPTY_STRING,
  privacyPolicyConstants,
} from "../../constants";
import MainSpinner from "../../shared/components/spinner/MainSpinner";
import convertContentToHTML from "../../shared/utility-functions/ConvertContentToHtml";
import MainContentWrapper from "../../shared/components/main-content-wrapper/MainContentWrapper";
import { privacyPolicyActions } from "../../redux/actions";
import Topbar from "../../layout/Topbar";
import Footer from "../../layout/Footer";

const { GET_PRIVACY_POLICY, ADD_OR_UPDATE_PRIVACY_POLICY } =
  privacyPolicyConstants;

const PrivacyPolicy = (props) => {
  const { isAuthenticated, privacyPolicy, spinnerActions, getPrivacyPolicy } =
    props;

  const [htmlContent, setHtmlContent] = useState(EMPTY_STRING);

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  useEffect(() => {
    if (privacyPolicy?.content) {
      const html = convertContentToHTML(privacyPolicy.content);
      setHtmlContent(html);
    }
  }, [privacyPolicy]);

  useEffect(() => {
    getPrivacyPolicy();

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {isAuthenticated ? (
        <Topbar />
      ) : (
        <Navbar
          bg="white"
          expand="sm"
          fixed="top"
          className="navbar align-items-center navbar__container"
        >
          <Container>
            <Navbar.Brand className="d-flex align-items-center">
              <img src={logoIcon} height={46} width={46} />
              <p className="brand-logo">Bayview Shores</p>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="align-items-start align-items-lg-center pt-0 mt-lg-0 mt-0 column-gap-3">
                <Nav.Link
                  as={Link}
                  to={SCREEN_PATH.LOGIN}
                  className="nav-item-btn my-2 my-lg-0"
                >
                  Login
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}
      {(spinner(GET_PRIVACY_POLICY) > -1 ||
        spinner(ADD_OR_UPDATE_PRIVACY_POLICY) > -1) && <MainSpinner />}
      <MainContentWrapper>
        <div className="container">
          <div className="about-us-heading">Privacy Policy</div>
          {spinner(GET_PRIVACY_POLICY) === -1 && (
            <div
              dangerouslySetInnerHTML={{ __html: htmlContent }}
              className="mt-4"
            />
          )}
        </div>
      </MainContentWrapper>
      {isAuthenticated ? (
        <Footer />
      ) : (
        <footer className="footer-wrapper">
          <div className="container">
            <div className="copyright">
              <p className="m-1">
                Copyright &copy; {new Date().getFullYear()}, Bayview Shores
              </p>
            </div>
          </div>
        </footer>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  spinnerActions: state.systemReducer.spinnerActions,
  isAuthenticated: state.authReducer.isAuthenticated,
  privacyPolicy: state.privacyPolicyReducer.privacyPolicy,
});

const mapDispatchToProps = (dispatch) => ({
  getPrivacyPolicy: () => dispatch(privacyPolicyActions.getPrivacyPolicy()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy);
